import { render, staticRenderFns } from "./personalPhrases.vue?vue&type=template&id=1a4d5120"
import script from "./personalPhrases.vue?vue&type=script&lang=js"
export * from "./personalPhrases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports